import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@components/Basic/ButtonNbe'
import { useTranslation } from 'react-i18next'
import { BillingNoticeWrapper } from '@features/billing/BillingNotificationBox/styled'
import { plansNamesById } from '@features/checkout/checkoutUtils'
import { appRoutes } from '@app/routes'
import { ApiPlan } from 'BackendApi'

interface PlanReactivationBoxProps {
  userCurrentPlan?: ApiPlan
  planId?: string
  isLegacyPlan?: boolean
}

export const PlanReactivationBox: React.FC<PlanReactivationBoxProps> = ({
  userCurrentPlan,
  planId,
  isLegacyPlan,
}) => {
  const { t } = useTranslation()

  const planNameFromLbPlan =
    userCurrentPlan?.lbPlan !== undefined
      ? plansNamesById[userCurrentPlan.lbPlan]
      : undefined
  const fallbackPlanSlug = planId ? planId.split('_')[0] : undefined
  const fallbackPlanName = fallbackPlanSlug
    ? `${fallbackPlanSlug.charAt(0).toUpperCase()}${fallbackPlanSlug.slice(1)}`
    : undefined
  const planNameForReactivation = planNameFromLbPlan || fallbackPlanName
  const reactivatePlanId = userCurrentPlan?.id || planId
  const reactivateUrl = appRoutes.checkout.makeUrl(reactivatePlanId)
  const planLabel =
    planNameForReactivation || t('billing.payment.unpaidPlanFallbackName')
  const messageKey = isLegacyPlan
    ? 'billing.payment.unpaidLegacyPlanMessage'
    : 'billing.payment.unpaidPlanMessage'

  return (
    <BillingNoticeWrapper>
      <div>
        <h4>{t('billing.payment.unpaidPlanTitle')}</h4>
        <p>
          {t(messageKey, {
            planName: planLabel,
          })}
        </p>
      </div>
      {!isLegacyPlan && (
        <Link to={reactivateUrl} style={{ textDecoration: 'none' }}>
          <Button type='button' $variant='action' $size='large'>
            {t('billing.payment.unpaidPlanCta')}
          </Button>
        </Link>
      )}
    </BillingNoticeWrapper>
  )
}
